import React from "react";
import RequestPreview from "./preview/RequestPreview";
import { isTouch } from "../../../utils/screenUtil";
import { faFolderOpen } from "@fortawesome/free-regular-svg-icons";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderPlus } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "../../../common/tooltip/Tooltip.js";

function Submitted({ title, requests, activeJournalId, setActiveJournalId }) {
  const history = useHistory();

  return (
    <>
      <div className="subtitle">{title}</div>
      {requests &&
        requests.map((request, index) => (
          <RequestPreview
            className={isTouch() && index > 0 ? "mt-6" : ""}
            key={`submitted${index}`}
            {...request}
            blur={activeJournalId && activeJournalId !== request.uid}
            setActiveJournalId={setActiveJournalId}
            renderRequestActions={() => (
              <>
                <Tooltip
                  content="Kreiraj dopis"
                  children={
                    <FontAwesomeIcon
                      className="is-clickable"
                      icon={faFolderPlus}
                      onClick={() =>
                        history.push(`/requests/${request.id}/submissions/${request.uid}/letter`)
                      }
                      size="2x"
                    />
                  }
                  direction="bottom"
                ></Tooltip>
                <div className="ml-4 mr-2"></div>
                <Tooltip
                  content="Pregled dokumenata na obradi"
                  children={
                    <FontAwesomeIcon
                      className="is-clickable"
                      icon={faFolderOpen}
                      onClick={() =>
                        history.push(
                          `/requests/${request.id}/submissions/${request.uid}/supplement`
                        )
                      }
                      size="2x"
                    />
                  }
                  direction="bottom"
                ></Tooltip>
              </>
            )}
          />
        ))}
    </>
  );
}

export default Submitted;
